"use client"

import type { TrackEventFn } from "./context"
import { TrackEventContext } from "./context"

export type TrackEventProviderProps = {
  trackEvent?: TrackEventFn
  children: React.ReactNode
}

export const TrackEventProvider = ({
  trackEvent,
  children,
}: TrackEventProviderProps) => {
  if (!trackEvent) {
    return children
  }

  return (
    <TrackEventContext.Provider value={{ trackEvent }}>
      {children}
    </TrackEventContext.Provider>
  )
}
